import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["element", "body"]

  async open(event) {
    event.preventDefault()
    this.elementTarget.classList.add("is-active")

    const url = event.currentTarget.getAttribute("href")
    if (!this.hasBodyTarget || !url || this.loaded) return

    try {
      const response = await fetch(url, { headers: { Accept: "text/html" } })
      if (!response.ok) return
      this.bodyTarget.innerHTML = await response.text()
      this.loaded = true
    } catch (e) {
      // mantém o placeholder; usuário pode tentar de novo fechando e abrindo
    }
  }

  close(event) {
    event?.preventDefault()
    this.elementTarget.classList.remove("is-active")
  }
}
